import VetAppointmentView from "./VetAppointmentView";
export default VetAppointmentView;